import React from 'react';
import PropTypes from 'prop-types';
import processString from 'react-process-string';

import { Link } from 'components';

const isEven = (number) => (number % 2 === 0);

const getScopeValue = (vars) => (match) => {
  const variable = vars[match.toLowerCase()];
  return (variable ?? `{{${match}}}`);
};

const replaceTags = processString([{
  regex: /<a+\shref=['"](.*?)['"]>(.*?)<\/a>/,
  fn: (key, result) => (
    <Link key={key} href={result[1]} target="_blank">
      {result[2]}
    </Link>
  ),
}, {
  regex: /<a onclick="(.*?)">(.*?)<\/a>/,
  fn: (key, result) => (
    <Link key={key} onClick={() => eval(result[1])}>
      {result[2]}
    </Link>
  ),
}, {
  regex: /\n/,
  fn: (key) => <br key={key} />,
}]);

export const I18nRaw = ({ vars = {}, className, style, html }) => {
  const variableGetter = getScopeValue(vars);

  if (typeof html !== 'string') {
    return null;
  }

  const result = replaceTags(html.split(/{{(\w+)}}/ig).reduce(
    // Every even index will be static string value (0, 2, 4, 6, etc.)
    // We need to convert only odd values
    (acc, next, index) => [...acc, isEven(index) ? next : variableGetter(next)],
    [],
  ));

  return (className || style) ? (
    <span className={className} style={style}>
      {result}
    </span>
  ) : (
    result
  );
};

I18nRaw.propTypes = {
  vars: PropTypes.object,
  className: PropTypes.any,
  style: PropTypes.object,
  html: PropTypes.string,
};
